<template>
	<div
		class="ms-combobox flex ms-editor relative"
		:class="{ isValid: errorProvider.isValid, disabled: disabled }"
	>
		<div class="selected-options">
			<div
				class="selected-item"
				v-for="(item, index) in listSelectedItem"
				:key="index"
			>
				<div class="item-text">{{ item[displayField] }}</div>
				<div
					class="icon-input ml-2"
					v-tooltip="{
						content: item.message,
						show: showTooltip(item),
						classes: `error`,
					}"
					v-show="item.isValid"
				>
					<div class="mi mi-24 mi-red-tick"></div>
				</div>
				<div
					class="item-icon mi-12 mi-new-v2 mi-icon-v2-close-12 cursor-pointer"
					@click.stop="deSelect(item)"
				></div>
			</div>
			<input
				ref="input"
				class="ms-input"
				:placeholder="placeholder"
				v-model="internalText"
				v-on="listeners"
				:readonly="readonly"
				:disabled="disabled"
				:class="{ readOnly: readonly }"
				@focus="autoFocusInput"
				v-show="
					listSelectedItem && listSelectedItem.length > 0 ? expanded : true
				"
			/>
			<div
				class="icon-input flex align-item-center"
				v-tooltip="{
					content: errorProvider.message,
					show: focused,
					classes: `error`,
					...(errorTooltipPlacement
						? { placement: errorTooltipPlacement }
						: {}),
				}"
				v-if="errorProvider.isValid"
			>
				<div class="mi mi-24 mi-red-tick mr-2"></div>
			</div>
		</div>

		<div
			@click="expand(!expanded)"
			class="icon-combo--dropdown"
			:class="{ readOnly: readonly, disabled: disabled }"
		>
			<div :class="['mi-new-v2 mi-16 mi-icon-v2-arrow-dropdown']"></div>
		</div>
		<ms-combo-box-dropdown
			ref="dropdownPanel"
			v-if="expanded"
			:topx="dropdownTopx"
			:leftx="dropdownLeftx"
			:maxWidthx="dropdownMaxWidthx"
			:minWidthx="dropdownMinWidthx"
			:columnx="columns"
			:comboType="comboType"
			:emptyText="data.length <= 0 ? emptyText : null"
			@removeAll="removeAllSelected"
			:isShowUnSelectAll="listSelectedItem.length > 0"
			:hasHeader="hasHeader"
			:serial="true"
			:maxItemsDisplay="maxItemsDisplay"
		>
			<MsRecycleScroller
				ref="scroller"
				:style="styleScroller"
				:items="internalDataSource"
				:itemSize="itemSize"
				:keyField="keyField"
				:emitUpdate="true"
				:buffer="0"
				:visiableIndex="typeAheadPointer"
				@visible="onScrollerVisible"
				@update="onScrollerUpdate"
				:customData="customData"
			>
				<template v-slot="{ item, index }">
					<ms-combo-box-item
						:comboType="comboType"
						:item="item"
						:columnx="columns"
						:valueField="valueField"
						:displayField="displayField"
						:class="{
							'ms-combobox-item--highlight': typeAheadPointer == index,
						}"
						@click="onItemClick(item, $event)"
						:serial="true"
						:rowIndex="index"
						:isIconSelect="isIconSelect"
						:checkbox="checkbox"
						@checkItem="checkboxItem"
					></ms-combo-box-item>
				</template>
			</MsRecycleScroller>
		</ms-combo-box-dropdown>
	</div>
</template>
<script>
import MsComboBoxDropdown from './MsComboBoxDropdown.vue';
import MsComboBoxItem from './MsComboBoxItem.vue';
import MsRecycleScroller from '@/components/msvirtualscroller/MsRecycleScroller';
import msBaseComponent from '@/components/msbase/msBaseComponent.vue';
import { isNullOrEmpty } from '../../common/objectUtil';
export default {
	name: 'msComboboxMultipleV2',
	extends: msBaseComponent,
	components: { MsComboBoxDropdown, MsRecycleScroller, MsComboBoxItem },
	props: {
		value: {
			default: () => [],
		},
		errorTooltipPlacement: {
			type: String,
			default: null,
		},
		placeholder: {
			default: null,
			type: [Number, String],
		},
		maxItemsDisplay: {
			default: 5,
			type: Number,
		},
		columns: {
			type: Array,
			default: () => [],
		},
		/**
		 * Trường làm value
		 * CreatedBy LTDAT 15.06.2020
		 */
		valueField: {
			type: String,
			default: null,
		},
		/**
		 * Trường làm text display
		 * CreatedBy LTDAT 15.06.2020
		 */
		displayField: {
			type: String,
			default: null,
		},
		//Dữ liệu của combobox
		data: {
			default: () => [],
			type: Array,
		},
		//Độ rộng của 1 item
		itemSize: {
			default: 36,
			type: Number,
		},
		//Chỉ nhận giá trị có trong danh sách
		forceSelection: {
			default: true,
			type: Boolean,
		},
		//Là combotree hay không
		isComboTree: {
			default: false,
			type: Boolean,
		},
		//Parent Field
		idProperty: {
			default: null,
			type: String,
		},
		//Field chứa parentID
		parentIdProperty: {
			default: 'ParentID',
			type: String,
		},
		//Không cho phép chọn trường là cha
		notSelectionParent: {
			default: false,
			type: Boolean,
		},
		//Độ rông của dropdown tính bằng px
		dropdownWidth: {
			default: null,
			type: [String, Number],
		},
		//Store xử lý dữ liệu trên liên quan đến data trong grid
		store: {
			default: null,
		},
		//Mode query lấy dữ liệu từ server hay client
		queryMode: {
			type: String,
			default: 'remote',
		},
		//Gán giá trị text lúc ban đầu
		initText: {
			default: null,
			type: [Number, String],
		},
		//Trạng thái có phân trang hay không
		pagination: {
			default: false,
			type: Boolean,
		},
		autoLoad: {
			default: false,
			type: Boolean,
		},
		keyField: {
			default: '__vKeyValue',
			type: String,
		},

		nameItem: {
			default: null,
			type: String,
		},

		//rule để validate từng giá trị trong multi
		rulesItem: {
			type: String,
			default: null,
		},
		autoFocus: {
			default: false,
			type: Boolean,
		},
		/**
		 * Có sử dụng phép phím cách để lựa chọn item trong combobox hay không
		 */
		isKeySpace: {
			default: false,
			type: Boolean,
		},
		/**
		 * Có sử dụng phép phím tab để lựa chọn item trong combobox hay không
		 */
		isKeyTab: {
			default: false,
			type: Boolean,
		},
		/**
		 * Có sử dụng phép phím enter để lựa chọn item trong combobox hay không
		 */
		isKeyEnter: {
			default: false,
			type: Boolean,
		},
		hasHeader: {
			default: false,
			type: Boolean,
		},
		isIconSelect: {
			default: false,
			type: Boolean,
		},
		initIndex: {
			default: -1,
			type: Number,
		},
		checkbox: {
			default: false,
			type: Boolean,
		},
		hasCheckAll: {
			default: false,
			type: Boolean,
		},
		indexDataAll: {
			default: -1,
			type: Number,
		},
		/**
		 * Đánh dấu khi chọn phần tử cuối thì không check all
		 */
		isNoCheckAll: {
			default: false,
			type: Boolean,
		},
		disabled: {
			default: false,
			type: Boolean,
		},
		emptyText: {
			default: 'Không có dữ liệu!',
			type: String,
		},
		customData: {},
	},
	computed: {
		listeners() {
			const me = this;
			return {
				input: (event) => me.onInput(event),
				focus: (event) => me.onFocus(event),
				change: (event) => me.onChange(event),
				blur: (event) => me.onBlur(event),
				keydown: (event) => me.onKeydown(event),
			};
		},
		//Tính độ rộng của dropdown combobox để scroll
		styleScroller() {
			const me = this;
			return { 'max-height': me.maxItemsDisplay * me.itemSize + 'px' };
		},
		valueDataAll() {
			const me = this;
			if (!me.internalDataSource || me.internalDataSource.length <= 0)
				return {};
			let dataAll = me.internalDataSource.find((x) => x.All);
			return dataAll ? dataAll : {};
		},
	},
	data() {
		const me = this;
		me.initStaticData();
		return {
			internalText: '',
			expanded: false,
			dropdownTopx: 0,
			dropdownLeftx: 0,
			internalSelectedItem: null,
			typeAheadPointer: -1,
			listSelectedItem: [],
			currentSkip: 0,
			focused: false,
			dataAll: {},
		};
	},
	//Hàm khởi tạo dữ liệu hook func
	created() {
		const me = this;
		me.initCombo();
		me.initData();
		me.setInitIndex();
		// Fix: setItemSelectedValue trong immediate watcher chạy trước initData
		// nên internalDataSource còn rỗng -> không restore được selected items
		me.setItemSelectedValue(me.value);
		if (me.autoLoad) {
			me.doQueryInternal(null, false);
		}
	},
	mounted() {
		const me = this;
		//Debounce query để delay load
		if (me.queryMode != 'remote') {
			me.internalQueryDelay = 20;
		}
		me.doQuery = _.debounce(me.doQueryInternal, me.internalQueryDelay);
		if (me.store) {
			me.store.pageAppend = true;
		}
	},
	beforeDestroy() {
		const me = this;
		setTimeout(() => {
			document.removeEventListener('mousedown', me.click_out);
		}, 100);
	},
	methods: {
		showTooltip(item) {
			const me = this;
			let itemError = [...me.listSelectedItem]
				.reverse()
				.find((x) => x.isValid == true);
			if (itemError && itemError.TaxCode == item.TaxCode) {
				return me.focused;
			} else {
				return false;
			}
		},

		/**
		 * Loại bỏ tất cả các lựa chọn
		 */
		removeAllSelected() {
			const me = this;
			me.internalDataSource.forEach((element) => {
				element.__multiSelected = false;
			});
			me.$emit('input', []);
			me.internalText = null;
			me.firstExpand = true;
		},
		deSelect(item) {
			let me = this;
			me.setInternalItemDefault(item);
		},
		/**
		 * Kiểm tra scroll đã đến bản ghi cuối cùng hay chưa
		 * Nếu load theo kiểu phân trang và số bản ghi trong combo nhỏ hơn tổng số bản ghi thi load tiếp dữ liệu vào store
		 * @param start: vị trí bắt đầu của view trong vitual scroll
		 * @param end: vị trí kết thúc của view trong vitual scroll
		 * Created by LTDAT(30.06.2020)
		 *  */
		async onScrollerUpdate(start, end) {
			const me = this;
			if (me.internalDataSource && end == me.internalDataSource.length) {
				let skip = Math.floor(me.internalDataSource.length / 20) * 20;
				if (skip > me.currentSkip) {
					let payload = {};
					if (me.pagination) {
						payload.Skip = skip;
						payload.Take = 20;
						payload.pageAppend = false;
						payload.SearchText = me.getQueryString();
					}
					me.currentSkip = skip;
					await me.$ms.commonFunc.emitPromise(me, 'loadData', payload);
					me.setItemSelectedValue(me.value);
				}
			}
		},
		/**
		 * Set giá trị hiện thị ban đầu cho combobox khi combo chưa có dữ liệu
		 * Created by LTDAT(25.06.2020)
		 */
		setInitText() {
			const me = this;
			me.internalText = me.initText;
		},
		/**
		 * Thực hiện query dữ liệu, có thể từ local hoặc remote tùy theo cấu hình
		 * CreatedBy LTDAT 11/12/2019
		 */
		doQueryInternal(searchString, expand = true, skip = 0) {
			let me = this,
				event = { preventDefault: false, sender: me },
				queryString = searchString != null ? searchString : me.getQueryString();
			me.$emit('beforeQuery', event);
			if (event.preventDefault) {
				return false;
			}
			if (me.lastQueryString == queryString) {
				me.expand(expand);
			} else {
				me.lastQueryString = queryString;
				me.querying = true;
				me.typeAheadPointer = -1;
				if (me.queryMode === 'remote' || (me.store && me.store.remoteFilter)) {
					me.doRemoteQuery(queryString, expand, skip).then((x) => {
						me.$ms.commonFunc.genVKeyValue(me.internalDataSource);
						me.afterQuery(expand);
						//Nếu đã có danh sách đã chọn thì gán lại giá trị đánh dấu cờ đã tích chọn
						if (me.listSelectedItem.length > 0) {
							me.internalDataSource.forEach((item) => {
								if (me.listSelectedItem.find((x) => x.Id == item.Id)) {
									item.__multiSelected = true;
								}
							});
						}
					});
				} else {
					me.doLocalQuery(queryString).then((x) => me.afterQuery(expand));
				}
			}
		},
		/**
		 * Xử lý sau khi query xong dữ liệu
		 * CreatedBy LTDAT 24.06.2020
		 */
		afterQuery(expand) {
			const me = this;
			me.expand(expand);
			me.typeAheadPointer = me.filterIndexItemByText();
		},
		/**
		 * Query dữ liệu api
		 * CreatedBy LTDAT 24.06.2020
		 */
		doRemoteQuery(queryString, expand, skip = 0) {
			//Build filter,
			let me = this,
				filters = [],
				filterFields = me.filterFields;
			return new Promise(async (resolve, reject) => {
				if (queryString) {
					for (const key in filterFields) {
						if (filterFields.hasOwnProperty(key)) {
							const f = filterFields[key];
							let filter = {
								property: key,
								value: queryString,
								operator: f,
								operand: 'or',
							};
							filters.push(filter);
						}
					}
				}
				let payload = {};
				if (me.pagination) {
					payload.Skip = skip;
					payload.Take = 20;
					payload.pageAppend = false;
					payload.SearchText = queryString;
				}
				me.currentSkip = 0;
				await me.$ms.commonFunc.emitPromise(me, 'loadData', payload);
				me.setItemSelectedValue(me.value);
			});
		},

		/**
		 * Query dữ liệu local
		 * CreatedBy LTDAT 24.06.2020
		 */
		doLocalQuery(queryString) {
			let me = this,
				store = me.store;

			return new Promise((resolve, reject) => {
				//Kiểm xem store đã load dữ liệu chưa, nếu chưa thì load lần đầu
				let p;
				if (me.autoLoad && store && !store._loaded && store.getCount() == 0) {
					let proxy = store.proxy;
					if (proxy && proxy.type === 'cache') {
						p = store.load();
					}
				}
				// if (store && store.proxy && store.proxy.type === 'cache') {
				// 	p = clientDatabase.fetchKey(store.proxy.keyCache).then(res => {
				// 		//Nếu cache thay đổi thì load lại
				// 		if (res) {
				// 			store.load();
				// 		}
				// 	});
				// }
				p ? p.then(resolve, reject) : resolve(false);
			}).then(() => {
				me.loading = false;
			});
		},
		/**
		 * Lấy chuỗi cần query, trường hợp number thì lấy value bỏ qua ký tự phân cách
		 * CreatedBy LTDAT 11/12/2019
		 */
		getQueryString() {
			return (this.internalText || '').trim();
		},
		//Click ra ngoài combo đóng combo lại
		//Created by LTDAT 18.06.2020
		click_out(e) {
			const me = this;
			if (
				me.$el &&
				!me.$ms.commonFunc.hasParent(e.target, me.$el) &&
				(!me.$refs.dropdownPanel ||
					(me.$refs.dropdownPanel &&
						!me.$ms.commonFunc.hasParent(e.target, me.$refs.dropdownPanel.$el)))
			) {
				me.expand(false);
			}
		},
		//Reset lại các giá trị trong combobox
		reset() {
			const me = this;
			me.internalText = '';
			me.internalSelectedItem = null;
			me.typeAheadPointer = -1;
			me.internalValue = null;
			// me.$emit('input', me.internalValue);
		},
		setInternalText(value) {
			const me = this;
			me.internalText = value;
		},
		setValue(value) {
			const me = this;
			me.internalValue = value;
			me.$emit('input', me.internalValue);
		},
		//Sự kiện nhập liệu trên input
		//Created by LTDAT (16.06.2020)
		onInput(e) {
			const me = this;
			if (!me.expanded) {
				me.expand(true);
			}
			if (!me.internalText) {
				if (me.internalValue) {
					let metaData = {
						oldData: me.internalSelectedItem,
						newData: null,
					};
					me.$emit('selected', metaData);
				}
				me.reset();
			}
			if (me.queryMode == 'remote' && me.remoteFilter) {
				me.doQuery(me.internalText, true);
			}
			me.typeAheadPointer = me.filterIndexItemByText();
			me.adjustScroll();
		},
		//Sự kiện focus vào input
		//Created by LTDAT (16.06.2020)
		onFocus(e) {
			const me = this;
			me.focused = true;
			me.$emit('focus', e);
		},
		//Sự kiện change input
		//Created by LTDAT (16.06.2020)
		onChange(e) {
			const me = this;
			if (me.internalText) {
				if (me.internalDataSource && me.internalDataSource.length > 0) {
					let keyByData = _.keyBy(me.internalDataSource, me.valueField);
					if (keyByData.hasOwnProperty(me.internalText)) {
						me.setInternalItem(keyByData[me.internalText]);
					} else {
						//Fix bug base comment logic thừa này đi 449341
						// let objNew = {};
						// me.$set(objNew, me.valueField, me.internalText);
						// me.setInternalItem(objNew);
						me.internalText = null;
					}
				}
			}
		},
		//Sự kiện blur input
		//Created by LTDAT (16.06.2020)
		onBlur(e) {
			const me = this;
			me.focused = false;
			me.$emit('blur', e);
		},
		//Sự kiện keydown input
		//Created by LTDAT (16.06.2020)
		onKeydown(e) {
			const me = this;
			me.focused = false;
			switch (e.which) {
				case 40: //Mũi tên xuống
					{
						if (!me.expanded) {
							me.expand(true);
						} else if (me.typeAheadPointer < me.getTotalData() - 1) {
							if (me.notSelectionParent) {
								let typeAheadPointerNext = me.typeAheadPointer + 1;
								for (let i = typeAheadPointerNext; i < me.getTotalData(); i++) {
									me.typeAheadPointer++;
									me.adjustScroll(typeAheadPointerNext);
									if (!me.internalDataSource[i].isParent) {
										break;
									}
								}
							} else {
								me.typeAheadPointer++;
								me.adjustScroll();
							}
						}
					}
					break;
				case 38: //Mũi tên lên
					{
						if (me.expanded) {
							if (me.typeAheadPointer > 0) {
								if (me.notSelectionParent) {
									let typeAheadPointerPre = me.typeAheadPointer - 1;
									for (let i = typeAheadPointerPre; i > 0; i--) {
										me.typeAheadPointer--;
										me.adjustScroll(me.typeAheadPointer);
										if (!me.internalDataSource[i].isParent) {
											break;
										}
									}
								} else {
									me.typeAheadPointer--;
									me.adjustScroll();
								}
							}
						}
					}
					break;
				case 13: //Enter
					if (me.isKeyEnter) {
						me.handleOnKeydown();
					}
					break;
				case 9: //Tab
					if (me.isKeyTab) {
						me.handleOnKeydown();
					}
					break;
				case 32: //Phím cách
					if (me.isKeySpace) {
						me.handleOnKeydown();
					}
					break;
			}
		},
		handleOnKeydown() {
			const me = this;
			event.preventDefault();
			if (me.typeAheadPointer >= 0) {
				me.setInternalItemDefault(me.internalDataSource[me.typeAheadPointer]);
			} else {
				if (me.customData && me.customData.isAddValueText) {
					//Có nhập dữ liệu để chọn
					if (me.internalText && me.internalText.trim()) {
						let objNew = {};
						me.$set(objNew, me.valueField, me.internalText);
						me.setInternalItem(objNew);
					}
				}
				me.internalText = null;
			}
		},
		getTotalData() {
			const me = this;
			return me.internalDataSource.length;
		},
		//Bôi màu hightlight cho item
		doHightlightItem() {
			const me = this;
			if (me.internalDataSource && me.internalDataSource.length > 0) {
				if (me.internalValue != null && me.internalValue != undefined) {
					//Trước khi load tính toán lại typeAheadPointer nếu cần thiết để scroll di chuyển về dúng vị trí khi show scroller lên
					//Tìm vị trí selectedItem trong source, không lấy selectedIndex vì có thể không chính xác khi source thay đổi
					let index = _.findIndex(
						me.internalDataSource,
						(item) => item[me.valueField] === me.internalValue
					);
					me.typeAheadPointer = index;
				}
			}
		},
		//Tìm kiếm item trong list
		//Created by LTDAT(16.06.2020)
		filterIndexItemByText() {
			const me = this;
			let filters = me.filterFields,
				value = me.internalText,
				index = -1;
			if (filters) {
				index = me.internalDataSource.findIndex((item, _index) => {
					let ret = false;
					for (const key in filters) {
						if (filters.hasOwnProperty(key)) {
							const s = filters[key];
							if (s == 'contains') {
								ret =
									item[key] &&
									item[key].toString() &&
									item[key]
										.toString()
										.toLowerCase()
										.contains(value.toLowerCase());
							} else {
								ret =
									item[key] &&
									item[key].toString() &&
									item[key]
										.toString()
										.toLowerCase()
										.startsWith(value.toLowerCase());
							}
							if (ret) {
								break;
							}
						}
					}
					return ret;
				});
			}
			me.adjustScroll();
			return index;
		},
		//Lấy cột filter để tìm kiếm local
		//Created by LTDAT 16.06.2020
		getFilterFields() {
			let filter = {};
			if (this.columns && this.columns.length > 0) {
				for (let i = 0; i < this.columns.length; i++) {
					const col = this.columns[i];
					if (!col.filterOperator) {
						col.filterOperator = 'contains';
					}
					if (col.dataField && col.filterOperator) {
						if (this.filterColumns && this.filterColumns.length > 0) {
							this.filterColumns.forEach((e) => {
								if (!filter.hasOwnProperty(e)) {
									filter[e] = col.filterOperator;
								}
							});
						} else {
							filter[col.dataField] = col.filterOperator;
						}
					}
				}
			} else {
				filter[this.displayField] = 'contains';
			}
			return filter;
		},
		//Lấy element scroll
		//Created by LTDAT (16.06.2020)
		getScroller() {
			if (this.expanded) {
				return this.$refs['scroller'];
			}
			return null;
		},
		/**
		 * Di chuyển view đến bản ghi nếu cần
		 * @param {Bản ghi cần view} index
		 * CreatedBy LTDAT 16.06.2020
		 */
		adjustScroll(typeAheadPointer = this.typeAheadPointer) {
			let scroller = this.getScroller();
			if (scroller) {
				scroller.scrollToItem(typeAheadPointer, true);
			}
		},
		onScrollerVisible() {
			const me = this;
			me.adjustScroll();
		},

		//Hàm xử lý khi chọn item trên dropdown
		//Created by LTDAT(16.06.2020)
		onItemClick(item, event) {
			const me = this;
			if (me.checkbox) {
			} else {
				me.setInternalItem(item);
			}
		},
		//Set giá trị được chọn
		setInternalItem: _.debounce(function (item) {
			let me = this;
			if (me.notSelectionParent && item.isParent) {
				return;
			}

			let metaData = {
				oldData: me.internalSelectedItem,
				newData: item,
				obdListData: me.listSelectedItem,
				newListData: [...me.listSelectedItem, item],
			};
			me.internalSelectedItem = item;
			me.internalValue = item[me.valueField];
			let itemInLists = me.listSelectedItem.find((_item) => {
				return _item[me.valueField] == item[me.valueField];
			});
			let VModel = me.value;
			if (!VModel) {
				VModel = [];
			}
			if (itemInLists) {
				let exist = VModel.find((x) => x[me.valueField] == me.internalValue);
				if (exist) {
					VModel.remove(exist);
					item.__multiSelected = false;
				}
			} else {
				let objNew = {};
				me.$set(objNew, me.valueField, me.internalValue);
				//Validate giá trị
				let validate = me.validateInput(objNew);
				if (validate && validate.isValid) {
					objNew.isValid = validate.isValid;
					objNew.message = validate.message;
				}

				VModel.push(objNew);
				item.__multiSelected = true;
			}

			me.$emit('input', VModel);
			me.internalText = null;
			// me.expand(false);
			me.$emit('selected', metaData);
			me.firstExpand = true;
		}, 200),

		/**
		 * Set dữ liệu không debounce
		 */
		setInternalItemDefault(item, isReset, isUpdate) {
			let me = this;
			let isSelectAll = item.All;
			if (me.notSelectionParent && item.isParent) {
				return;
			}

			let metaData = {
				oldData: me.internalSelectedItem,
				newData: item,
				obdListData: me.listSelectedItem,
				newListData: [...me.listSelectedItem, item],
			};
			me.internalSelectedItem = item;
			me.internalValue = item[me.valueField];

			let checkSelected = item.__multiSelected;
			let itemInLists = me.listSelectedItem.find((_item) => {
				return _item[me.valueField] == item[me.valueField];
			});
			let VModel = [];
			VModel = me.value;
			if (!VModel) {
				VModel = [];
			}
			if (itemInLists) {
				if (isReset) {
					me.internalDataSource.forEach((element) => {
						element.__multiSelected = true;
					});
					VModel = [];
					me.setValueForVModel(VModel, me.internalValue);
				} else if (isSelectAll) {
					me.internalDataSource.forEach((element) => {
						element.__multiSelected = false;
					});
					VModel = [];
					me.internalSelectedItem = [];
				} else {
					// Bỏ chọn item
					let exist = VModel.find((x) => x[me.valueField] == me.internalValue);
					if (exist) {
						VModel.remove(exist);
						me.$emit('delete', exist);
					}
					item.__multiSelected = false;
				}
			} else {
				//Tích chọn tất cả
				if (isSelectAll) {
					me.internalDataSource = me.$ms.commonFunc.cloneDeepData(
						me.internalDataSource
					);
					me.internalDataSource.forEach((element) => {
						element.__multiSelected = true;
					});
					VModel = [];
					me.setValueForVModel(VModel, me.internalValue);
				} else {
					//Kiểm tra xem đang có chọn tất cả hay không - loại bỏ các đang chọn, lựa chọn các cái còn lại
					let existAll = VModel.find(
						(x) =>
							!me.isNoCheckAll &&
							x[me.valueField] == me.valueDataAll[me.valueField]
					);
					if (existAll) {
						VModel = [];
						me.internalDataSource.forEach((element) => {
							if (
								element[me.valueField] == item[me.valueField] ||
								element[me.valueField] == me.valueDataAll[me.valueField]
							) {
								element.__multiSelected = false;
							} else {
								element.__multiSelected = true;
								me.setValueForVModel(VModel, element[me.valueField]);
							}
						});
					} else {
						//Tích chọn 1
						let checkExistItemVModel = VModel.find(
							(x) => x[me.valueField] == item[me.valueField]
						);
						if (checkExistItemVModel) return;
						me.setValueForVModel(VModel, me.internalValue);
						item.__multiSelected = true;

						//Chọn item con cuối cùng - chọn luôn item tất cả
						if (
							VModel.length + 1 == me.internalDataSource.length &&
							!me.isNoCheckAll
						) {
							VModel = [];
							me.internalDataSource.forEach((element) => {
								if (element[me.valueField] == me.valueDataAll[me.valueField]) {
									element.__multiSelected = true;
									me.setValueForVModel(VModel, element[me.valueField]);
								}
							});
						}
					}
				}
			}

			if (!isUpdate) {
				me.$emit('input', VModel);
			}
			me.internalText = null;
			me.$emit('selected', metaData);
			// me.firstExpand = true;
		},

		setInternalItemsParent(items) {
			const me = this;
			if (!items || items.length <= 0) return;
			let VModel = [];
			items = me.$ms.commonFunc.distinctArray(items, me.valueField);
			let existAll = items.find(
				(x) => x[me.valueField] == me.valueDataAll[me.valueField]
			);
			if (existAll) {
				me.internalDataSource.forEach((element) => {
					element.__multiSelected = true;
				});
				// me.setValueForVModel(VModel, existAll[me.valueField]);
			} else {
				me.internalDataSource.forEach((element) => {
					let dataExist = items.find(
						(x) => x[me.valueField] == element[me.valueField]
					);
					if (dataExist) {
						element.__multiSelected = true;
						// me.setValueForVModel(VModel, dataExist);
					} else {
						element.__multiSelected = false;
					}
				});
			}

			me.$emit('input', items);
		},

		setInternalItems(items) {
			const me = this;
			if (!items || items.length <= 0) return;
			let checkDataSelectAll = items.find(
				(x) =>
					me.internalDataSource[me.initIndex] &&
					me.internalDataSource[me.indexDataAll][me.valueField] ==
						x[me.valueField]
			);
			if (checkDataSelectAll) return;
			let VModel = [];
			VModel = items;
			if (!VModel) {
				VModel = [];
			}
			me.internalDataSource.forEach((element) => {
				let checkExist = items.find(
					(x) => x[me.valueField] == element[me.valueField]
				);
				if (checkExist) {
					element.__multiSelected = true;
				}
			});
		},

		setValueForVModel(VModel, internalValue, isFirst) {
			const me = this;
			let objNew = {};
			me.$set(objNew, me.valueField, internalValue);

			//Validate giá trị
			let validate = me.validateInput(objNew);
			if (validate && validate.isValid) {
				objNew.isValid = validate.isValid;
				objNew.message = validate.message;
			}

			let checkExist = VModel.find(
				(x) => x[me.valueField] == objNew[me.valueField]
			);
			if (!checkExist) {
				VModel.push(objNew);
			}
		},

		//Tìm vị trị của item trong data
		findIndexItem(item) {
			const me = this;
			return me.internalDataSource.findIndex((_item) => {
				return _item == item;
			});
		},
		//Khởi tạo dữ liệu tĩnh mặc định
		initStaticData() {
			const me = this;
			me.comboType = 1;
			me.internalDataSource = [];
			me.internalQueryDelay = 200;
			me.filterFields = me.getFilterFields();
			me.focused = false;
			me.internalValue = null;
			me.firstExpand = true;
		},
		//Khởi tạo dữ liệu
		initData() {
			const me = this;
			if (me.store) {
				me.internalDataSource = me.store.data.items;
			} else {
				me.internalDataSource = me.data;
			}
			me.$ms.commonFunc.genVKeyValue(me.internalDataSource);
			//Nếu là combo dạng tree
			if (me.comboType == 3) {
				let dataTree = me.$ms.commonFunc.nomalizeDataTree(
					me.internalDataSource,
					me.idProperty,
					me.parentIdProperty
				);
				me.internalDataSource = me.$ms.commonFunc.getBodyData(dataTree, true);
			}
		},

		/**
		 * NNThao thêm để đè lại dữ liệu khi có xử lý thêm sau khi computed
		 */
		setDataSourceReplace(data, isShowForm = false) {
			const me = this;
			me.internalDataSource = me.$ms.commonFunc.getBodyData(data, true);
			me.setInitIndex(isShowForm);
		},

		setInitIndex(isReset) {
			const me = this;
			if (
				me.initIndex >= 0 &&
				me.internalDataSource &&
				me.internalDataSource.length > 0
			) {
				if (isReset) {
					me.setInternalItemDefault(
						me.internalDataSource[me.indexDataAll],
						isReset
					);
				} else {
					// me.typeAheadPointer = me.initIndex;
					let checkDataSelectAll =
						me.value != null &&
						me.value.find(
							(x) =>
								me.internalDataSource[me.initIndex] &&
								me.internalDataSource[me.indexDataAll][me.valueField] ==
									x[me.valueField]
						);

					if (checkDataSelectAll) {
						me.setInternalItemDefault(me.internalDataSource[me.indexDataAll]);
					} else if (me.value && me.value.length > 0) {
						me.setInternalItems(me.value);
					}
				}
			}
		},
		/**
		 * Khởi tạo combo
		 *
		 * @author hngiap - 01.09.2019
		 * 1 là combo không có columns (ComboEditor)
		 * 2 là combo có columns
		 * 3 là combo tree
		 */
		initCombo() {
			const me = this;
			if (me.isComboTree) {
				me.comboType = 3;
			} else if (me.columns && me.columns.length !== 0) {
				me.comboType = 2;
			} else {
				me.comboType = 1;
			}
		},
		//Đóng mở combobox
		expand(mode = !this.expanded) {
			const me = this;
			if (me.firstExpand) {
				if (me.queryMode == 'remote') {
					me.firstExpand = false;
					me.doQueryInternal(null, true);
				}
			}
			if (mode == true) {
				me.$emit('beforeExpand');
				document.addEventListener('mousedown', me.click_out);
			} else {
				document.removeEventListener('mousedown', me.click_out);
			}
			me.$emit('expand', mode);
			me.expanded = mode;
			me.doHightlightItem();
			if (me.$refs.input) {
				me.$refs.input.focus();
			}
			me.changeDropdownPosition(mode);
			me.setItemSelectedValue(me.value);
		},
		/**
		 * Hàm set vị trí cho dropdown menu khi expand
		 * TODO: Chưa xử lý khi có scroll
		 */
		changeDropdownPosition(isExpand = true) {
			let me = this;
			if (!me.$el) return;

			if (me.$ms.commonFunc.checkSmallScreen()) {
				//Bắn sự kiện trước khi thay đổi vị trí dropdown
				me.$emit('beforeChangeDropdownPosition', isExpand);
			}
			let comboEl = me.$el,
				comboElRect = comboEl.getBoundingClientRect(),
				comboMenuEl = me.$el;

			let windowWidth =
				window.innerWidth ||
				document.documentElement.clientWidth ||
				document.body.clientWidth;

			let windowHeight =
				window.innerHeight ||
				document.documentElement.clientHeight ||
				document.body.clientHeight;

			me.dropdownLeftx = comboElRect.left;
			me.dropdownTopx = comboElRect.top + comboElRect.height + 2;
			me.dropdownMaxWidthx = me.dropdownMinWidthx = me.dropdownWidth
				? me.dropdownWidth
				: comboElRect.width;

			// Nếu chạm phải thì align sang trái
			if (comboElRect.left + comboMenuEl.offsetWidth > windowWidth) {
				me.dropdownLeftx = comboElRect.right - comboMenuEl.offsetWidth;
			}

			// Nếu chạm bottom thì align top
			if (
				comboElRect.bottom + me.itemSize * me.maxItemsDisplay + 2 >
				windowHeight
			) {
				me.dropdownTopx =
					comboElRect.top -
					(me.itemSize *
						Math.min(me.maxItemsDisplay, me.internalDataSource.length) +
						4);
			}
		},
		setItemSelectedValue(newVal) {
			const me = this;
			if (newVal) {
				if (Array.isArray(newVal)) {
					me.listSelectedItem = [];
					newVal.forEach((item) => {
						me.internalValue = item[me.valueField];
						me.doHightlightItem();
						if (me.typeAheadPointer >= 0) {
							me.internalDataSource[me.typeAheadPointer].__multiSelected = true;
							me.listSelectedItem.push(
								me.internalDataSource[me.typeAheadPointer]
							);
						} else if (me.valueField == me.displayField) {
							let tempObj = {};
							tempObj[me.valueField] = item[me.valueField];
							tempObj.__multiSelected = true;
							tempObj.isValid = item.isValid;
							tempObj.message = item.message;
							me.listSelectedItem.push(tempObj);
						}
					});
				}
			} else {
				me.reset();
			}
		},

		validate(editor, data = null, isConnect = false, dataOptions) {
			const me = this;
			if (me.disabled) {
				me.errorProvider = {};
				return me.errorProvider;
			}
			let listRules = [],
				rulesValidate = null,
				ret = false;
			if (me.rules) {
				listRules = me.rules.split('|');
			}

			let valueSelect =
				me.listSelectedItem && me.listSelectedItem.length > 0
					? 'listSelectedItem'
					: '';
			for (let i = 0; i < listRules.length; i++) {
				ret = !me.validateRule(
					listRules[i],
					valueSelect,
					editor,
					data,
					isConnect,
					dataOptions
				);
				if (ret) {
					rulesValidate = listRules[i];
					break;
				}
			}
			if (ret) {
				if (me.$t('i18nValidate.messages')[rulesValidate]) {
					me.$set(
						me.errorProvider,
						'message',
						me
							.$t('i18nValidate.messages')
							[rulesValidate](me.nameItem ? me.nameItem : me.title)
					);
				}
				me.$set(me.errorProvider, 'isValid', true);
				me.errorProvider.rules = rulesValidate;
				me.errorProvider.element = me.$refs.input;
			} else {
				me.errorProvider = {};
			}
			return me.errorProvider;
		},

		validateInput(data) {
			const me = this;
			let listRules = [],
				rulesValidate = null,
				ret = false;
			if (me.rulesItem) {
				listRules = me.rulesItem.split('|');
			}
			for (let i = 0; i < listRules.length; i++) {
				ret = !me.validateRule(listRules[i], data[me.valueField], null);
				if (ret) {
					rulesValidate = listRules[i];
					break;
				}
			}
			if (ret) {
				if (me.$t('i18nValidate.messages')[rulesValidate]) {
					me.$set(
						data,
						'message',
						me
							.$t('i18nValidate.messages')
							[rulesValidate](me.nameItem ? me.nameItem : me.name)
					);
				}
				me.$set(data, 'isValid', true);
			} else {
				me.$set(data, 'isValid', false);
				me.$set(data, 'message', null);
			}
			me.$set(data, 'element', me.$refs.input);
			return data;
		},

		validateItemSelect(data) {
			const me = this;
			let listRules = [],
				rulesValidate = null,
				ret = false;
			if (me.rulesItem) {
				listRules = me.rulesItem.split('|');
			}
			for (let i = 0; i < listRules.length; i++) {
				ret = !me.validateRule(listRules[i], data[me.valueField], null);
				if (ret) {
					rulesValidate = listRules[i];
					break;
				}
			}
			if (ret) {
				if (me.$t('i18nValidate.messages')[rulesValidate]) {
					me.$set(
						data,
						'message',
						me
							.$t('i18nValidate.messages')
							[rulesValidate](me.nameItem ? me.nameItem : me.name)
					);
				}
				me.$set(data, 'isValid', true);
			} else {
				me.$set(data, 'isValid', false);
				me.$set(data, 'message', null);
			}
			me.$set(data, 'element', me.$refs.input);
			return data;
		},
		/**
		 * Hàm sử lí việc autoFocus ô input
		 */
		autoFocusInput(e) {
			const me = this;
			//Focus vào ô input
			if (me.autoFocus) {
				me.$ms.commonFunc.focusFirstControl(me.$el);
			}
		},

		checkboxItem(item) {
			const me = this;
			me.setInternalItemDefault(item);
			// document.removeEventListener('mousedown', me.click_out);
			// me.expand(false);
			// me.expanded = false;
		},

		isCheckDataAll(item) {
			const me = this;
			if (
				!me.internalDataSource ||
				me.internalDataSource.length <= 0 ||
				!item ||
				me.indexDataAll < 0 ||
				!me.internalDataSource[me.indexDataAll]
			)
				return false;

			let dataAll = me.internalDataSource[me.indexDataAll];
			return dataAll[me.valueField] == item[me.valueField];
		},
		closeComboboxDropdown() {
			const me = this;
			me.expanded = false;
		},

		resetDataDefault() {
			const me = this;
			me.reset();
			me.setInitIndex(true);
		},

		resetInternalDataSource() {},
	},
	watch: {
		/**
		 * Set lại giá trị hiển thị khi giá trị của biến initText thay đổi
		 */
		initText: {
			immediate: true,
			handler(newVal, oldVal) {
				const me = this;
				me.setInitText(newVal);
			},
		},
		/**
		 * Kiểm tra nếu text hiện thị thay đổi thi validate
		 */
		// internalText: {
		// 	handler(newVal, oldVal) {
		// 		const me = this;
		// 		newVal = newVal ? newVal : '';
		// 		oldVal = oldVal ? oldVal : '';
		// 		if (newVal != oldVal) {
		// 			//nvnam3: validate thêm trường hợp muốn kiểm tra text có trong danh sách combobox hay không
		// 			let data = me.internalDataSource;
		// 			me.validate(newVal, data);
		// 		}
		// 		// me.$emit('changeText', newVal);
		// 		// // me.$emit('input',newVal);
		// 	},
		// },
		listSelectedItem: {
			handler(newVal, oldVal) {
				const me = this;
				if (newVal != oldVal) {
					me.validate(newVal);
				}
				me.$nextTick(() => {
					me.changeDropdownPosition(me.expanded);
				});
				// me.$emit('changeText', newVal);
				// // me.$emit('input',newVal);
			},
		},
		/**
		 * Nếu giá trị VModel của combo thay đổi thì gán lại giá trị mới và select vào item tương ứng có trong data
		 */
		value: {
			immediate: true,
			handler(newVal, oldVal) {
				const me = this;
				me.setItemSelectedValue(newVal);
			},
		},

		data: {
			handler(newVal, oldVal) {
				const me = this;
				if (newVal) {
					me.internalDataSource = newVal;
					//Check xem có sự thay đổi về dữ liệu danh sách và được thực hiện load lại các dữ liệu được chọn trong combobox bug 461541
					if (
						newVal &&
						newVal.length > 0 &&
						newVal.find((x) => x && x.isReloadData)
					) {
						me.setInitIndex(true);
					}
				}
			},
		},
	},
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/_sm-variables.scss';
@import '@/assets/scss/components/msCombo.scss';

.selected-options {
	display: flex;
	flex-basis: 100%;
	flex-grow: 1;
	flex-wrap: wrap;
	max-width: calc(100% - 25px);
	.selected-item {
		display: flex;
		align-items: center;
		border-radius: 6px;
		background: var(--color-neutral-200);
		border: 1px solid var(--ms-color-border);
		padding: 4px 8px;
		margin: 4px 4px 4px 12px;
		max-width: calc(100% - 4px);
		height: 24px;
		.item-text {
			font-size: $font-size-small;
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
			-webkit-line-clamp: 1;
			max-width: 100%;
		}

		.item-icon {
			margin-left: 6px;
		}
	}

	.selected-item:not(:last-child) {
		margin-right: 2px;
	}

	.ms-input {
		border: none;
		font-size: $font-size-body-new;
		padding: 5px 10px;
		padding-right: unset;
		text-overflow: ellipsis;
		background-color: transparent;
		display: flex;
		flex: 1;
	}
	.ms-input::placeholder {
		font-size: $font-size-medium;
		font-style: italic;
		color: $grey;
	}
}
</style>